import { render } from "./Share_Account_Details.vue?vue&type=template&id=891beb7e&scoped=true"
import script from "./Share_Account_Details.vue?vue&type=script&lang=js"
export * from "./Share_Account_Details.vue?vue&type=script&lang=js"

import "./Share_Account_Details.vue?vue&type=style&index=0&id=891beb7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891beb7e"]])

export default __exports__